import { render, staticRenderFns } from "./productEditTabInformation.vue?vue&type=template&id=6a84cb07&scoped=true&"
import script from "./productEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./productEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./productEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84cb07",
  null
  
)

export default component.exports